import SideMenu from './SideMenu';

interface MobileNavigationProps {
  badges: Record<string, number>;
  onSelect: () => void;
}

/** 复用正式菜单的权限、锁定与外链判断，成功站内跳转后关闭左侧抽屉。 */
export default function MobileNavigation({
  badges,
  onSelect,
}: MobileNavigationProps) {
  return <SideMenu badges={badges} mobile onNavigate={onSelect} />;
}
